document.addEventListener("DOMContentLoaded", function() {
    /* 
    var endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      // method: 'click',
      offset: 1000
    });
     */
    let elem = document.querySelector('#AjaxinateContainer');
    let infScroll = new InfiniteScroll( elem, {
      // options
      path: '.pagination__next',
      append: '.blog-articles__article.article',
      history: false,
      container: elem,
      status: '.scroller-status',
    });
  });